define('core/views/AutoplayRichMediaView',[
    'underscore',
    'jquery',
    'core/utils',
    'core/views/IframeRichMediaView',
], function (
    _,
    $,
    utils,
    IframeRichMediaView
) {
    'use strict';

    return IframeRichMediaView.extend({
        // Support autoplay of YouTube, Vimeo, Vine, and SoundCloud embeds
        createContentNode: function () {
            var $node = IframeRichMediaView.prototype.createContentNode.apply(this, arguments);

            var src = $node.attr('src');
            // Do not enable autoplay if we are going to use playerjs,
            // as it will be played via 'send'
            if (this.shouldAutoplay() && src && !this.model.get('playerjs')) {
                src = utils.serialize(src, {
                    // Early SoundCloud embeds, pre embedly iframe src
                    auto_play: true,
                    // Everything else
                    autoplay: 1,
                });
                $node.attr('src', src);
            }

            return $node;
        },

        insertContentNode: function ($node) {
            if (this.model.get('playerjs')) {
                // Communicate with player using Player.js Spec
                // https://github.com/embedly/player.js/blob/master/SPEC.rst
                var $iframe = this._findIframe($node);

                var src = $iframe.attr('src');
                if (src.substr(0, 2) === '//')
                    src = window.location.protocol + src;

                var origin = src.split('/');
                origin = origin[0] + '//' + origin[2];

                this.playerjs = {
                    ready: false,
                    queue: [],
                    origin: origin,
                    $iframe: $iframe,
                };

                if (this.model.get('mute'))
                    this.send('mute');

                // To guarantee the embed is muted before it plays, createContentNode
                // will not enable autoplay via the iframe src.
                if (this.shouldAutoplay())
                    this.send('play');

                var readyFn = _.once(_.bind(function () {
                    this.playerjs.ready = true;
                    // Send queued messages
                    var queue = this.playerjs.queue;
                    this.playerjs.queue = [];
                    _.each(queue, this.send, this);
                }, this));

                $(window).on('message', function (event) {
                    event = event.originalEvent;

                    if (event.origin !== origin)
                        return;

                    var data;
                    try {
                        data = JSON.parse(event.data);
                    } catch (err) {
                        return;
                    }

                    if (data.event === 'ready' && data.value && data.value.src === src)
                        readyFn();
                });
            }

            return IframeRichMediaView.prototype.insertContentNode.apply(this, arguments);
        },

        send: function (method) {
            if (!this.playerjs)
                return;

            if (!this.playerjs.ready)
                return void this.playerjs.queue.push(method);

            var data = {
                context: 'player.js',
                version: '0.0.10',
                method: method,
            };

            this.playerjs.$iframe[0].contentWindow.postMessage(
                JSON.stringify(data), this.playerjs.origin);
        },
    });
});

